import styled from 'styled-components'

const StepHeaderTitle = styled.div`
	font-size: 16px;
	font-weight: bold;
`

export default StepHeaderTitle